// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'investment-sale.page.title': 'Investment Sales',
    'investment-sale.page.search_results': 'Search Results',
    'investment-sale.page.create.title': 'New Sale',
    'investment-sale.page.search.title': 'Find Investment Sales',
    'investment-sale.page.edit.title': 'Edit Investment Sale',
    'investment-sale.page.view.title': 'View Investment Sale',
    'investment-sale.page.all': 'All',

    'investment-sale.button.cancel': 'Cancel',
    'investment-sale.button.select': 'Select',
    'investment-sale.button.find': 'Find Investment Sales',
    'investment-sale.button.search': 'Apply',
    'investment-sale.button.create': 'Add Sale',
    'investment-sale.button.new': 'New Investment Sale',
    'investment-sale.button.save': 'Save Changes',
    'investment-sale.button.void': 'Void Sale',
    'investment-sale.button.redo': 'Redo Sale',
    'investment-sale.button.rollback': 'Rollback Sale',
    'investment-sale.button.edit': 'Edit',
    'investment-sale.button.restore': 'Restore',
    'investment-sale.button.reset': 'Reset',

    'investment-sale.placeholder.search': 'Search investment sales',

    'investment-sale.link.create_first_investment_sale': 'Click here to create your first investment sale',
    'investment-sale.link.investment_sales': 'Sale to Investment Sales',
    'investment-sale.link.retry': 'Click here to retry',

    'investment-sale.checkbox.all': 'Check All',
    'investment-sale.checkbox.actions_label': 'with selected',

    'investment-sale.label.investment_name': 'Investment',
    'investment-sale.label.transaction_date': 'Transaction Date',
    'investment-sale.label.currency_name': 'Currency',
    'investment-sale.label.units_sold': 'Units Sold',
    'investment-sale.label.currency_amount_in_cents': 'Currency Amount',
    'investment-sale.label.currency_value_of_remaining_units': 'Value Of Remaining Units',
    'investment-sale.label.rollback_reason': 'Reason for rollback',
    'investment-sale.label.bank_general_ledger_account_name': 'Paid To Bank Account',
    'investment-sale.label.reference_code': 'Reference Code',
    'investment-sale.label.memo': 'Memo',

    'investment-sale.sort.field_label': 'Field',
    'investment-sale.sort.direction_label': 'Direction',
    'investment-sale.sort.direction_ascending': 'Ascending',
    'investment-sale.sort.direction_descending': 'Descending',

    'investment-sale.modal.title.investment_sale_void': 'Void Investment Sale',
    'investment-sale.modal.title.investment_sale_rollback': 'Rollback Investment Sale',

    'investment-sale.modal.message.investment_sale_void': 'Are you sure that you want to void this investment sale?',
    'investment-sale.modal.message.investment_sale_rollback': 'Are you sure that you want to rollback this investment sale?',

    'investment-sale.success.message.investment_sale_created': 'Your investment sale has been created',
    'investment-sale.success.message.investment_sale_updated': 'Your investment sale has been updated',
    'investment-sale.success.message.investment_sale_rolled_back': 'Your investment sale has been rolled back',
    'investment-sale.success.message.investment_sale_voided': 'Your investment sale has been voided',

    'investment-sale.error.message.investment_sale_deleted': 'This investment sale was already permanently deleted | These investment sales were already permanently deleted',
    'investment-sale.error.message.investment_sale_restored': 'This investment sale was already restored | These investment sales were already restored',
    'investment-sale.error.message.error_loading_page': 'Sorry, there was an error loading investment sale.| Sorry, there was an error loading investment sales.',
};
